
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { truncateFct } from '../../helpers/truncate';

export default defineComponent({
	name: 'ArticleDownloadSection',
	methods: {
		truncateFct,
		getReadableName(url: string): string {
			const decodedUrl = decodeURIComponent(url);
			const urlParts = decodedUrl.split('/');
			const part = urlParts[urlParts.length - 1].replace('file_', '');
			const removeIndex = part.indexOf('_');

			return part.substr(0, removeIndex);
		}
	},
	props: {
		fullDownloadUrls: { type: Array as PropType<string[]>, required: true },
		isCompanyPage: { type: Boolean }
	}
});
